(function () {'use strict';}());

angular.module('app')
  .controller('LoginController', function ($scope,$timeout,AppService) {
  	var trace = angular.trace;

    $scope.pin = null;
    $scope.processing = false;
    $scope.errorMessage = null;

    $scope.authenticate = function(){
      if(!$scope.pin) return alert("You must enter a PIN. Please contact your counselor if you need to recover it.");
      if($scope.pin.length < 4) return alert("Your PIN should have between 4 and 6 characters. Please contact your counselor if you have forgotten your access code.");
      $scope.processing = true;
      $scope.errorMessage = null;
      $scope.containerClasses.saving = true;

      AppService.authenticate($scope.pin).then(onAuthenticationResult);
    };

    function onAuthenticationResult(result)
    {
      if(result.data.successfulLogin) $scope.launchApp().then(function(){$scope.processing = false; $scope.containerClasses.saving = false;});
      else badLogin();
    }
    function badLogin()
    {
      $scope.containerClasses.saving = false;
      $scope.errorMessage = "Failed login attempt. Please contact your counselor if you have forgotten your access code.";
    }
  });
